import React from 'react';
import { ThemeProvider } from 'styled-components';

import GlobalStyle from './GlobalStyle';
import { theme } from './theme';

function RLThemeProvider(props) {
  return (
    <ThemeProvider theme={props.theme}>
      <props.GlobalStyle />
      {props.children}
    </ThemeProvider>
  );
}

RLThemeProvider.defaultProps = {
  GlobalStyle: GlobalStyle,
  theme: theme,
};

export default RLThemeProvider;
